<template>
    <div class="row q-gutter-x-sm items-center" :style="{ 'overflow': overflow }">
        <component class="col" v-for="(component, index) in components" :key="index" v-bind:is="component.name" :params="component.params"></component>
    </div>
</template>

<script>
import uiControlMixin from 'src/mixins/ui/uiControlMixin';

export default {
    name: 'Container',
    mixins: [uiControlMixin],
    props: {
        view: {
            type: Object,
            default: undefined,
        },
    },
    mounted () {
        const { uuid } = this.view;
        this.load(uuid);
    },
    computed: {
        overflow () {
            return this.params.overflow ?? '';
        },
    },
    data () {
        return {
            components: [],
        };
    },
    methods: {
        load (uuid) {
            this.$factory.loadViews(uuid).then((components) => {
                this.components = components;
                this.error = components.length === 0;
            });
        },
    },
};
</script>

<style scoped>

</style>
